export const FORM_CODE_FF014 = 'FF014';

export type YesNo = 'yes' | 'no';

export type PreEmploymentEducationFormValues = {
  educationUnderstood?: YesNo | '';
  agree?: 'true' | 'false' | '';
  /** ISO date from server when FF014 agree was first given. */
  consentDateFf014?: string;
};

export type PreEmploymentEducationStep = 'materialsUnderstood' | 'agree';
